var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.allLoaded
    ? _c("div", { class: _vm.wrapperClass }, [
        _c("button", { class: _vm.buttonClass, on: { click: _vm.loadMore } }, [
          _vm._v("\n    " + _vm._s(_vm.loadMoreText) + "\n  "),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }